import { Locales } from './types';

export { default as deDE } from './translations/web/de-de.json';
export { default as enUS } from './translations/web/en-us.json';
export { default as esES } from './translations/web/es-es.json';
export { default as nlNL } from './translations/web/nl-nl.json';

export const fallbackLocale = Locales.EnUS;

export { Locales };
